import _classCallCheck from "/codebuild/output/src1962210774/src/terraform-aws-website-terega-sol/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src1962210774/src/terraform-aws-website-terega-sol/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src1962210774/src/terraform-aws-website-terega-sol/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src1962210774/src/terraform-aws-website-terega-sol/application/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src1962210774/src/terraform-aws-website-terega-sol/application/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
}; // src/YouTube.tsx


import PropTypes from "prop-types";
import React from "react";
import isEqual from "fast-deep-equal";
import youTubePlayer from "youtube-player";

function shouldUpdateVideo(prevProps, props) {
  var _a, _b;

  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  var prevVars = ((_a = prevProps.opts) == null ? void 0 : _a.playerVars) || {};
  var vars = ((_b = props.opts) == null ? void 0 : _b.playerVars) || {};
  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

function filterResetOptions() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __spreadProps(__spreadValues({}, opts), {
    height: 0,
    width: 0,
    playerVars: __spreadProps(__spreadValues({}, opts.playerVars), {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

function shouldResetPlayer(prevProps, props) {
  return prevProps.videoId !== props.videoId || !isEqual(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

function shouldUpdatePlayer(prevProps, props) {
  var _a, _b, _c, _d;

  return prevProps.id !== props.id || prevProps.className !== props.className || ((_a = prevProps.opts) == null ? void 0 : _a.width) !== ((_b = props.opts) == null ? void 0 : _b.width) || ((_c = prevProps.opts) == null ? void 0 : _c.height) !== ((_d = props.opts) == null ? void 0 : _d.height) || prevProps.iframeClassName !== props.iframeClassName || prevProps.title !== props.title;
}

var defaultProps = {
  videoId: "",
  id: "",
  className: "",
  iframeClassName: "",
  style: {},
  title: "",
  loading: void 0,
  opts: {},
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
var propTypes = {
  videoId: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  iframeClassName: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  loading: PropTypes.oneOf(["lazy", "eager"]),
  opts: PropTypes.objectOf(PropTypes.any),
  onReady: PropTypes.func,
  onError: PropTypes.func,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onEnd: PropTypes.func,
  onStateChange: PropTypes.func,
  onPlaybackRateChange: PropTypes.func,
  onPlaybackQualityChange: PropTypes.func
};

var _YouTube = /*#__PURE__*/function (_React$Component) {
  _inherits(_YouTube, _React$Component);

  var _super = _createSuper(_YouTube);

  function _YouTube(props) {
    var _this;

    _classCallCheck(this, _YouTube);

    _this = _super.call(this, props);

    _this.onPlayerReady = function (event) {
      var _a, _b;

      return (_b = (_a = _this.props).onReady) == null ? void 0 : _b.call(_a, event);
    };

    _this.onPlayerError = function (event) {
      var _a, _b;

      return (_b = (_a = _this.props).onError) == null ? void 0 : _b.call(_a, event);
    };

    _this.onPlayerStateChange = function (event) {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      (_b = (_a = _this.props).onStateChange) == null ? void 0 : _b.call(_a, event);

      switch (event.data) {
        case _YouTube.PlayerState.ENDED:
          (_d = (_c = _this.props).onEnd) == null ? void 0 : _d.call(_c, event);
          break;

        case _YouTube.PlayerState.PLAYING:
          (_f = (_e = _this.props).onPlay) == null ? void 0 : _f.call(_e, event);
          break;

        case _YouTube.PlayerState.PAUSED:
          (_h = (_g = _this.props).onPause) == null ? void 0 : _h.call(_g, event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      var _a, _b;

      return (_b = (_a = _this.props).onPlaybackRateChange) == null ? void 0 : _b.call(_a, event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      var _a, _b;

      return (_b = (_a = _this.props).onPlaybackQualityChange) == null ? void 0 : _b.call(_a, event);
    };

    _this.createPlayer = function () {
      if (typeof document === "undefined") return;

      var playerOpts = __spreadProps(__spreadValues({}, _this.props.opts), {
        videoId: _this.props.videoId
      });

      _this.internalPlayer = youTubePlayer(_this.container, playerOpts);

      _this.internalPlayer.on("ready", _this.onPlayerReady);

      _this.internalPlayer.on("error", _this.onPlayerError);

      _this.internalPlayer.on("stateChange", _this.onPlayerStateChange);

      _this.internalPlayer.on("playbackRateChange", _this.onPlayerPlaybackRateChange);

      _this.internalPlayer.on("playbackQualityChange", _this.onPlayerPlaybackQualityChange);

      if (_this.props.title || _this.props.loading) {
        _this.internalPlayer.getIframe().then(function (iframe) {
          if (_this.props.title) iframe.setAttribute("title", _this.props.title);
          if (_this.props.loading) iframe.setAttribute("loading", _this.props.loading);
        });
      }
    };

    _this.resetPlayer = function () {
      var _a;

      return (_a = _this.internalPlayer) == null ? void 0 : _a.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      var _a;

      (_a = _this.internalPlayer) == null ? void 0 : _a.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute("id", _this.props.id);else iframe.removeAttribute("id");
        if (_this.props.iframeClassName) iframe.setAttribute("class", _this.props.iframeClassName);else iframe.removeAttribute("class");
        if (_this.props.opts && _this.props.opts.width) iframe.setAttribute("width", _this.props.opts.width.toString());else iframe.removeAttribute("width");
        if (_this.props.opts && _this.props.opts.height) iframe.setAttribute("height", _this.props.opts.height.toString());else iframe.removeAttribute("height");
        if (_this.props.title) iframe.setAttribute("title", _this.props.title);else iframe.setAttribute("title", "YouTube video player");
        if (_this.props.loading) iframe.setAttribute("loading", _this.props.loading);else iframe.removeAttribute("loading");
      });
    };

    _this.getInternalPlayer = function () {
      return _this.internalPlayer;
    };

    _this.updateVideo = function () {
      var _a, _b, _c, _d;

      if (typeof _this.props.videoId === "undefined" || _this.props.videoId === null) {
        (_a = _this.internalPlayer) == null ? void 0 : _a.stopVideo();
        return;
      }

      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };

      if ((_b = _this.props.opts) == null ? void 0 : _b.playerVars) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;

        if ("start" in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }

        if ("end" in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      if (autoplay) {
        (_c = _this.internalPlayer) == null ? void 0 : _c.loadVideoById(opts);
        return;
      }

      (_d = _this.internalPlayer) == null ? void 0 : _d.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  _createClass(_YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a;

      (_a = this.internalPlayer) == null ? void 0 : _a.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement("div", {
        className: this.props.className,
        style: this.props.style
      }, /* @__PURE__ */React.createElement("div", {
        id: this.props.id,
        className: this.props.iframeClassName,
        ref: this.refContainer
      }));
    }
  }]);

  return _YouTube;
}(React.Component);

var YouTube = _YouTube;
YouTube.propTypes = propTypes;
YouTube.defaultProps = defaultProps;
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};
var YouTube_default = YouTube;
export { YouTube_default as default };